import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfiniteSelectComponent } from './infinite-select.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [InfiniteSelectComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule
  ],
  exports: [
    InfiniteSelectComponent
  ]
})
export class InfiniteSelectSettlementsModule {}
